import React from 'react';
import Container from '@material-ui/core/Container';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import ProTip from './ProTip';
import { Todo } from './Todo';

export default function App() {
  return (
    <Container maxWidth="sm">
      <Box my={4}>
        <Typography variant="h4" component="h1" gutterBottom style={{ textAlign: 'center' }}>
          Nemesys Turbo V0.0001
        </Typography>
        <ProTip />
        <Todo />
      </Box>
    </Container>
  );
}
